module.exports = __webpack_public_path__ + "static/media/Assessment.4702bd35.svg";